import { getChartRevenues, getChartCategories } from "@/utils";
export default {
  getChartData(state) {
    return state.chartData;
  },
  getBenchmarkCohortData(state) {
    return state.benchmarkCohortData;
  },
  getSegmentDashboardData(state) {
    return state.segmentDashboardData;
  },
  getQueryData(state) {
    return state.queryData;
  },
  getChartSeries(state) {
    let chartData = state.chartData;
    let series = [];
    if (chartData.charts) {
      for (let i = 0; i < chartData.charts.length; i++) {
        let item = chartData.charts[i];
        series.push({
          name: item.name,
          data: getChartRevenues(item.data)
        });
      }
    }
    return series;
  },
  getChartCategories(state) {
    let chartData = state.chartData;
    let categories = [];
    // Get the categories of the first item
    if (chartData.charts) {
      for (let i = 0; i < chartData.charts.length; i++) {
        let item = chartData.charts[i];
        categories = getChartCategories(item.data);
        break;
      }
    }
    return categories;
  },
  getEmailCampaigns(state) {
    let chartData = state.chartData;
    return chartData.emails;
  },
  getAttributableRevenue(state) {
    let chartData = state.chartData;
    return chartData.revenue;
  }
};
